import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageSquare, Paperclip } from 'lucide-react';
import config from '../config.json';

const TableView = ({ tasks, onEdit, onAddTask }) => {
  const [expandedSections, setExpandedSections] = useState({});

  // Grouper les tâches par status
  const tasksByStatus = {};
  config.columns.filter(col => !col.hidden).forEach(column => {
    const statusTasks = tasks.filter(task => task.status === column.id);
    if (statusTasks.length > 0) {
      tasksByStatus[column.id] = {
        title: column.title,
        tasks: statusTasks,
        count: statusTasks.length
      };
    }
  });

  const toggleSection = (status) => {
    setExpandedSections(prev => ({
      ...prev,
      [status]: !prev[status]
    }));
  };

  return (
    <div className="flex-1 overflow-auto p-6">
      <div className="space-y-6">
        {Object.entries(tasksByStatus).map(([status, data]) => {
          const isExpanded = expandedSections[status] !== false; // Par défaut ouvert

          return (
            <div key={status} className="rounded-xl overflow-hidden">
              {/* Section Header */}
              <div
                onClick={() => toggleSection(status)}
                className="bg-column px-6 py-4 cursor-pointer hover:bg-opacity-90 transition-colors flex items-center justify-between"
              >
                <div className="flex items-center gap-3">
                  {isExpanded ? (
                    <ChevronUp className="w-5 h-5 text-foreground" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-foreground" />
                  )}
                  <h3 className="text-foreground font-semibold text-lg">
                    {data.title}
                  </h3>
                  <span className="text-muted text-sm">
                    {data.count}
                  </span>
                </div>
              </div>

              {/* Table Content */}
              {isExpanded && (
                <div className="bg-column">
                  {/* Table Headers */}
                  <div className="grid grid-cols-12 gap-4 px-6 py-3 border-b border-background/20">
                    <div className="col-span-1 text-xs text-muted font-medium">•••</div>
                    <div className="col-span-3 text-xs text-muted font-medium">Tâche</div>
                    <div className="col-span-1 text-xs text-muted font-medium">Pièces</div>
                    <div className="col-span-2 text-xs text-muted font-medium">Commentaires</div>
                    <div className="col-span-2 text-xs text-muted font-medium">Assignés</div>
                    <div className="col-span-2 text-xs text-muted font-medium">Tags</div>
                    <div className="col-span-1 text-xs text-muted font-medium"></div>
                  </div>

                  {/* Task Rows */}
                  {data.tasks.map((task, index) => (
                    <div
                      key={task.id}
                      onClick={() => onEdit(task)}
                      className={`grid grid-cols-12 gap-4 px-6 py-4 cursor-pointer hover:bg-background/30 transition-colors ${
                        index < data.tasks.length - 1 ? 'border-b border-background' : ''
                      }`}
                    >
                      {/* Menu Dots */}
                      <div className="col-span-1 flex items-center">
                        <span className="text-muted text-xl">•••</span>
                      </div>

                      {/* Task Title & Description */}
                      <div className="col-span-3 flex flex-col justify-center">
                        <div className="text-foreground font-medium text-sm">
                          {task.title} {task.contractNumber}
                        </div>
                        {task.contractReason && (
                          <div className="text-muted text-xs mt-1 truncate">
                            {task.contractReason}
                          </div>
                        )}
                      </div>

                      {/* Attachments */}
                      <div className="col-span-1 flex items-center">
                        {task.hasCall && (
                          <div className="flex items-center gap-1 text-muted">
                            <Paperclip className="w-4 h-4" />
                          </div>
                        )}
                      </div>

                      {/* Comments */}
                      <div className="col-span-2 flex items-center">
                        <div className="flex items-center gap-2 text-muted text-sm">
                          <MessageSquare className="w-4 h-4" />
                          <span>0 commentaires</span>
                        </div>
                      </div>

                      {/* Assigned Users */}
                      <div className="col-span-2 flex items-center">
                        <div className="text-foreground text-sm">
                          {task.agent}
                        </div>
                      </div>

                      {/* Tags */}
                      <div className="col-span-2 flex items-center gap-2">
                        {task.title && (
                          <span className="px-2 py-1 rounded text-xs font-medium bg-[#f87171]/20 text-[#f87171]">
                            {task.title}
                          </span>
                        )}
                        {task.contractStatus && (
                          <span className="px-2 py-1 rounded text-xs font-medium bg-[#60a5fa]/20 text-[#60a5fa]">
                            {task.contractStatus}
                          </span>
                        )}
                      </div>

                      {/* More Options */}
                      <div className="col-span-1 flex items-center justify-end">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className="p-1 hover:bg-background rounded transition-colors text-muted"
                        >
                          <span className="text-xl">⋮</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TableView;
